/* Product tabs (sections/rk-product-tabs.liquid): buttons with role=tab, arrow keys, hash deep links,
   and the Klaviyo star line in the buy box opens the Reviews tab. Re-inits on theme-editor section loads. */
(() => {
  const HASH_TO_TAB = { reviews: 'reviews', 'klaviyo-reviews-all': 'reviews', questions: 'questions', delivery: 'delivery', description: 'description', contents: 'contents' };

  const init = (root) => {
    if (root.dataset.rkTabsReady) return;
    root.dataset.rkTabsReady = '1';
    // Scoped to OUR bar/panels: the Klaviyo widget inside the Reviews panel renders role=tab buttons of its own.
    const tabs = Array.from(root.querySelectorAll('.rk-ptabs__bar > [role="tab"]'));
    const panels = Array.from(root.querySelectorAll('.rk-ptabs__panels > [role="tabpanel"]'));
    if (!tabs.length) return;
    const has = (name) => tabs.some((t) => t.dataset.tab === name);

    const activate = (name, focus) => {
      tabs.forEach((t) => {
        const on = t.dataset.tab === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach((p) => { p.hidden = p.dataset.panel !== name; });
    };
    const show = (name) => {
      if (!has(name)) return false;
      activate(name);
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return true;
    };

    tabs.forEach((t, i) => {
      t.addEventListener('click', () => activate(t.dataset.tab));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        activate(tabs[(i + d + tabs.length) % tabs.length].dataset.tab, true);
      });
    });

    const fromHash = () => {
      const name = HASH_TO_TAB[location.hash.replace('#', '')];
      if (name) show(name);
    };
    window.addEventListener('hashchange', fromHash);
    fromHash();

    // Klaviyo's star line ("★★★★½ 13 reviews") under the title → the Reviews tab.
    document.querySelectorAll('.klaviyo-star-rating-widget').forEach((w) => {
      w.style.cursor = 'pointer';
      w.addEventListener('click', (e) => { if (show('reviews')) e.preventDefault(); }, true);
    });
  };

  const initAll = () => document.querySelectorAll('.rk-ptabs').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.rk-ptabs').forEach(init));
})();
